import { createFileRoute } from '@tanstack/react-router';
import { NumbersPage } from '../../features/settings/components/numbers-page.js';

export const Route = createFileRoute('/admin/numbers')({ component: NumbersPage });
